// @flow
import React, { type Node } from 'react';
import { hot } from 'react-hot-loader';
import Helmet from 'react-helmet-async';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { legacyAnalytics, urlCatalog } from 'angieslist-app-platform';
import Loader from 'angieslist-app-platform/lib/browser/Loader';
import { Alert, Grid, Col, Row, Panel } from 'angieslist-react-components';
import { stylesColors } from 'angieslist-styles';
import _ from 'lodash';
import './dealsView.scss';
import dealAnalytics from './dealAnalytics';
import CouponCarousel from './components/CouponCarousel';
import DealCardGrid from './components/DealCardGrid';
import DealsEmptyState from './components/DealsEmptyState';
import dealsActions from '../common/dealsActions';
import type { Coupon, Deal } from '../types';
import type { DealsReducerState } from '../common/dealsReducer';

const { white } = stylesColors;

type Props = {
  // redux state
  deals: DealsReducerState,
  // redux actions
  getCoupons: typeof dealsActions.getCoupons,
  getDeals: typeof dealsActions.getDeals,
  // router
  params: {
    serviceProviderId: string
  }
};

const addInventory = ((
  <Panel
    className="deals-edit-inventory"
    style={{
      marginTop: 10,
    }}
  >
    <div className="text-center">
      <strong>
        <i
          className="icon icon-lg icon-outlined-offercard text-danger"
          style={{
          marginRight: 10,
        }}
        />
        <span>
          {' To add or edit deal inventory, call your Account Rep at '}
        </span>
        <a
          id="deals--edit-deal-inventory-phone-link"
          href={urlCatalog.global.businessCenterPhone()}
          className="text-nowrap"
        >
          {urlCatalog.global.businessCenterPhoneText()}
        </a>
      </strong>
    </div>
  </Panel>
));

export class DealsViewComponent extends React.Component<Props> {
  componentDidMount() {
    const { getCoupons, getDeals, params: { serviceProviderId } } = this.props;
    getCoupons(serviceProviderId);
    getDeals(serviceProviderId);
  }
  props: Props;
  render(): Node {
    const {
      deals: {
        coupons: {
          isLoading: couponsIsLoading,
          response: couponsResponse,
        },
        deals: {
          isLoading,
          response,
          error,
        },
      },
      getDeals,
      params: {
        serviceProviderId,
      },
    } = this.props;
    const deals: Deal[] = _.get(response, 'offers');
    const dealsCount = _.get(deals, 'length', 0);
    const coupons: Coupon[] = _.get(couponsResponse, 'coupons', []);
    const totalCount: number = _.get(response, 'totalCount', 0);
    return (
      <Grid>
        <Helmet>
          <title>Deals</title>
        </Helmet>
        <Row>
          <Col xs={12}>
            <h1>
              Deals
            </h1>
          </Col>
        </Row>
        <Loader
          loading={_.isUndefined(deals) || isLoading || couponsIsLoading}
          element={
            <Row style={{ paddingLeft: '1em' }}>
              <i className="icon icon-load icon-spin icon-3x text-primary" />
            </Row>}
        >
          <Row>
            <Col lg={9} sm={8} xs={12}>
              <If condition={error}>
                <Alert bsStyle="danger">There has been an error.</Alert>
              </If>
              <If condition={dealsCount > 0}>
                {addInventory}
                <DealCardGrid
                  deals={deals}
                  totalCount={totalCount}
                  onSelect={(offset) => {
                    getDeals(serviceProviderId, offset);
                  }}
                />
              </If>
              <If condition={dealsCount === 0}>
                <DealsEmptyState />
              </If>
            </Col>
            <Col lg={3} sm={4} xs={12}>
              <If condition={coupons.length > 0}>
                <div style={{
                  backgroundColor: white,
                  boxShadow: '0 2px 5px 0 rgba(0,0,0,.3)',
                }}
                >
                  <CouponCarousel key="coupon-carousel" coupons={coupons} />
                </div>
              </If>
            </Col>
          </Row>
        </Loader>
      </Grid>
    );
  }
}

export default (hot(module)(compose(
  legacyAnalytics({
    ruleset: dealAnalytics,
  }),
  connect(
    state => ({
      deals: state.deals,
    }),
    dealsActions,
  ),
  pure,
)(DealsViewComponent)): any);



// WEBPACK FOOTER //
// ./src/modules/store/browser/DealsView.js